var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("section", [
      _c("h3", [_vm._v("主题")]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "Qcharts 几乎所有的样式都在一个独立的配置文件中，通过修改这个配置文件，可以让 Qcharts 进行全局换肤，修改方式如下："
        )
      ]),
      _vm._v(" "),
      _c("pre", { pre: true }, [
        _c(
          "code",
          { pre: true, attrs: { "v-pre": "", class: "language-js" } },
          [
            _c("span", { pre: true, attrs: { class: "hljs-keyword" } }, [
              _vm._v("const")
            ]),
            _vm._v(" { theme } = qcharts\ntheme.set({\n  "),
            _c("span", { pre: true, attrs: { class: "hljs-attr" } }, [
              _vm._v("colors")
            ]),
            _vm._v(": ["),
            _c("span", { pre: true, attrs: { class: "hljs-string" } }, [
              _vm._v("'#71dac7'")
            ]),
            _vm._v(", "),
            _c("span", { pre: true, attrs: { class: "hljs-string" } }, [
              _vm._v("'#d57a77'")
            ]),
            _vm._v("],\n  "),
            _c("span", { pre: true, attrs: { class: "hljs-attr" } }, [
              _vm._v("visuals")
            ]),
            _vm._v(": {\n    "),
            _c("span", { pre: true, attrs: { class: "hljs-attr" } }, [
              _vm._v("Line")
            ]),
            _vm._v(": {\n      "),
            _c("span", { pre: true, attrs: { class: "hljs-comment" } }, [
              _vm._v("//折线图")
            ]),
            _vm._v("\n      "),
            _c("span", { pre: true, attrs: { class: "hljs-attr" } }, [
              _vm._v("styles")
            ]),
            _vm._v(": {\n        "),
            _c("span", { pre: true, attrs: { class: "hljs-attr" } }, [
              _vm._v("point")
            ]),
            _vm._v(": { "),
            _c("span", { pre: true, attrs: { class: "hljs-attr" } }, [
              _vm._v("pointType")
            ]),
            _vm._v(": "),
            _c("span", { pre: true, attrs: { class: "hljs-string" } }, [
              _vm._v("'star'")
            ]),
            _vm._v(" }\n      },\n      "),
            _c("span", { pre: true, attrs: { class: "hljs-attr" } }, [
              _vm._v("sttrs")
            ]),
            _vm._v(": {}\n    },\n    "),
            _c("span", { pre: true, attrs: { class: "hljs-attr" } }, [
              _vm._v("Area")
            ]),
            _vm._v(": {\n      "),
            _c("span", { pre: true, attrs: { class: "hljs-comment" } }, [
              _vm._v("//面积图")
            ]),
            _vm._v("\n      "),
            _c("span", { pre: true, attrs: { class: "hljs-attr" } }, [
              _vm._v("styles")
            ]),
            _vm._v(": {},\n      "),
            _c("span", { pre: true, attrs: { class: "hljs-attr" } }, [
              _vm._v("sttrs")
            ]),
            _vm._v(": {}\n    },\n    "),
            _c("span", { pre: true, attrs: { class: "hljs-attr" } }, [
              _vm._v("Bar")
            ]),
            _vm._v(": {\n      "),
            _c("span", { pre: true, attrs: { class: "hljs-comment" } }, [
              _vm._v("//柱状图")
            ]),
            _vm._v("\n      "),
            _c("span", { pre: true, attrs: { class: "hljs-attr" } }, [
              _vm._v("styles")
            ]),
            _vm._v(": {},\n      "),
            _c("span", { pre: true, attrs: { class: "hljs-attr" } }, [
              _vm._v("sttrs")
            ]),
            _vm._v(": {}\n    }\n    "),
            _c("span", { pre: true, attrs: { class: "hljs-comment" } }, [
              _vm._v("//...")
            ]),
            _vm._v("\n  },\n  "),
            _c("span", { pre: true, attrs: { class: "hljs-attr" } }, [
              _vm._v("plugins")
            ]),
            _vm._v(": {\n    "),
            _c("span", { pre: true, attrs: { class: "hljs-comment" } }, [
              _vm._v("// 富矿提示")
            ]),
            _vm._v("\n    "),
            _c("span", { pre: true, attrs: { class: "hljs-attr" } }, [
              _vm._v("Tooltip")
            ]),
            _vm._v(": {\n      "),
            _c("span", { pre: true, attrs: { class: "hljs-attr" } }, [
              _vm._v("styles")
            ]),
            _vm._v(": {},\n      "),
            _c("span", { pre: true, attrs: { class: "hljs-attr" } }, [
              _vm._v("attrs")
            ]),
            _vm._v(": {}\n    },\n    "),
            _c("span", { pre: true, attrs: { class: "hljs-comment" } }, [
              _vm._v("// 坐标轴")
            ]),
            _vm._v("\n    "),
            _c("span", { pre: true, attrs: { class: "hljs-attr" } }, [
              _vm._v("Axis")
            ]),
            _vm._v(": {\n      "),
            _c("span", { pre: true, attrs: { class: "hljs-attr" } }, [
              _vm._v("styles")
            ]),
            _vm._v(": {},\n      "),
            _c("span", { pre: true, attrs: { class: "hljs-attr" } }, [
              _vm._v("attrs")
            ]),
            _vm._v(": {}\n    }\n    "),
            _c("span", { pre: true, attrs: { class: "hljs-comment" } }, [
              _vm._v("//...")
            ]),
            _vm._v("\n  }\n})\n")
          ]
        )
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v("通过 "),
        _c("code", { pre: true }, [_vm._v("qcharts.theme")]),
        _vm._v(" 可以获取到默认的全局 theme 配置，方便对属性进行查看修改")
      ]),
      _vm._v(" "),
      _c("img", {
        attrs: {
          src: "https://p0.ssl.qhimg.com/t018869aae1d36f086b.jpg",
          width: "572"
        }
      }),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "也可以单独设置某个组件的样式,单独通过 style 设置的优先级高于统一 theme 设置"
        )
      ]),
      _vm._v(" "),
      _c("pre", { pre: true }, [
        _c(
          "code",
          { pre: true, attrs: { "v-pre": "", class: "language-js" } },
          [
            _c("span", { pre: true, attrs: { class: "hljs-keyword" } }, [
              _vm._v("const")
            ]),
            _vm._v(" line = "),
            _c("span", { pre: true, attrs: { class: "hljs-keyword" } }, [
              _vm._v("new")
            ]),
            _vm._v(" Line()\nline.style("),
            _c("span", { pre: true, attrs: { class: "hljs-string" } }, [
              _vm._v("'point'")
            ]),
            _vm._v(", { "),
            _c("span", { pre: true, attrs: { class: "hljs-attr" } }, [
              _vm._v("pointType")
            ]),
            _vm._v(": "),
            _c("span", { pre: true, attrs: { class: "hljs-string" } }, [
              _vm._v("'star'")
            ]),
            _vm._v(", "),
            _c("span", { pre: true, attrs: { class: "hljs-attr" } }, [
              _vm._v("angles")
            ]),
            _vm._v(": "),
            _c("span", { pre: true, attrs: { class: "hljs-number" } }, [
              _vm._v("5")
            ]),
            _vm._v(", "),
            _c("span", { pre: true, attrs: { class: "hljs-attr" } }, [
              _vm._v("innerRadius")
            ]),
            _vm._v(": "),
            _c("span", { pre: true, attrs: { class: "hljs-number" } }, [
              _vm._v("5")
            ]),
            _vm._v(", "),
            _c("span", { pre: true, attrs: { class: "hljs-attr" } }, [
              _vm._v("outerRadius")
            ]),
            _vm._v(": "),
            _c("span", { pre: true, attrs: { class: "hljs-number" } }, [
              _vm._v("10")
            ]),
            _vm._v(", "),
            _c("span", { pre: true, attrs: { class: "hljs-attr" } }, [
              _vm._v("strokeColor")
            ]),
            _vm._v(": "),
            _c("span", { pre: true, attrs: { class: "hljs-string" } }, [
              _vm._v("'#fff'")
            ]),
            _vm._v(" })\nline.style("),
            _c("span", { pre: true, attrs: { class: "hljs-string" } }, [
              _vm._v("'point:hover'")
            ]),
            _vm._v(", { "),
            _c("span", { pre: true, attrs: { class: "hljs-attr" } }, [
              _vm._v("strokeColor")
            ]),
            _vm._v(": "),
            _c("span", { pre: true, attrs: { class: "hljs-string" } }, [
              _vm._v("'#f0f'")
            ]),
            _vm._v(" })\n")
          ]
        )
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }